import { Box } from "@mui/material";
import CustomTheme from "components/Theme";
import Nav from "components/layout/Nav";
import TransitionRoute from "./components/TransitionRoute";
import { Content, NavStyle } from "./styled";

const AppRouter = () => {
  return (
    <CustomTheme>
      <Box
        sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <NavStyle>
          <Nav />
        </NavStyle>
        <Content>
          <TransitionRoute />
        </Content>
      </Box>
    </CustomTheme>
  );
};

export default AppRouter;
